import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String'];
}>;


export type InvoiceQuery = { readonly __typename?: 'Query', readonly invoice?: { readonly __typename?: 'Invoice', readonly transactions: ReadonlyArray<{ readonly __typename?: 'Transaction', readonly _id?: string | null, readonly type?: Types.TransactionType | null, readonly timestamp?: string | null, readonly actionedBy?: { readonly __typename?: 'InvoiceUser', readonly person?: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null } | null } | null, readonly amount?: { readonly __typename?: 'Amount', readonly value: number, readonly currency: Types.BillingCurrency } | null, readonly payment?: { readonly __typename?: 'PaymentDetails', readonly paymentMethod: Types.PaymentMethod, readonly authCode?: string | null } | null }> } | null };


export const InvoiceDocument = gql`
    query invoice($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    transactions {
      _id
      actionedBy {
        person {
          firstname
          middlename
          lastname
        }
      }
      type
      timestamp
      amount {
        value
        currency
      }
      payment {
        paymentMethod
        authCode
      }
    }
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;